import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getDevice } from '@panel/commons/helpers';
import { Wrapper, Container, Title, SubTitle, CardContainer, OptionCard, OptionTitle } from './styles';
import { options, handleRedirect, useNewPublisherEnabled } from './utils';

const PublicationType = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const device = getDevice();
  const isNewPublisherEnabled = useNewPublisherEnabled();

  return (
    <Wrapper data-publi='publication-type-wrapper' device={device}>
      <Container data-publi='publication-type-container' device={device}>
        <Title data-publi='publication-type-title' device={device}>
          {t('professionalPubli.publicationType.title')}
        </Title>
        <SubTitle data-publi='publication-type-subtitle' device={device}>
          {t('professionalPubli.publicationType.subtitle')}
        </SubTitle>
        <CardContainer data-publi='publication-type-card-container' device={device}>
          {options.map(option => (
            <OptionCard
              key={option.id}
              data-publi={`publication-type-card-${option.id}`}
              device={device}
              onClick={() => handleRedirect(option, history, isNewPublisherEnabled)}
            >
              {option.icon}
              <OptionTitle device={device}>
                <b>{t(option.ctaText)}</b>
                {t(option.description)}
              </OptionTitle>
            </OptionCard>
          ))}
        </CardContainer>
      </Container>
    </Wrapper>
  );
};

export default PublicationType;
